import React, { createContext, useCallback, useContext, useState } from 'react';
import { Content, Lesson } from '../../../../types';
import { ExtendedUnitWithHeaFragment, ExtendedHeaUnitFragment, Section } from '../../../../api/graphql-codegen'
export type SelectionLevel = 'Unit' | 'Lesson' | 'Content' | 'SectionContent' | undefined;

type EditUnitContextType = {
  unit: ExtendedUnitWithHeaFragment | undefined;
  setUnit: (unit: ExtendedUnitWithHeaFragment) => void;
  heaUnit: ExtendedHeaUnitFragment | null | undefined;
  setHeaUnit: (unit?: ExtendedHeaUnitFragment | null) => void;
  lesson: Lesson | undefined;
  setLesson: (lesson: Lesson | undefined) => void;
  section: Section | undefined;
  setSection: (section: Section | undefined) => void;
  content: (Content & { originalModuleId?: string | null }) | undefined;
  setContent: (content: Content | undefined) => void;
  selectionLevel: SelectionLevel;
  setSelectionLevel: (level: SelectionLevel) => void;
  isPreparation: boolean | undefined;
  setIsPreparation: (isPreparation: boolean | undefined) => void;
};

const noop = () => void 0;

const defaultContext: EditUnitContextType = {
  unit: undefined,
  setUnit: noop,
  heaUnit: undefined,
  setHeaUnit: noop,
  lesson: undefined,
  setLesson: noop,
  section: undefined,
  setSection: noop,
  content: undefined,
  setContent: noop,
  selectionLevel: undefined,
  setSelectionLevel: noop,
  isPreparation: undefined,
  setIsPreparation: noop,
};

const EditUnitContext = createContext<EditUnitContextType>(defaultContext);

type Props = {
  children: React.ReactNode;
}
export const EditUnitProvider = (props: Props) => {
  const { children } = props;
  const [unit, setUnitContent] = useState<ExtendedUnitWithHeaFragment | undefined>();
  const [heaUnit, setHeaUnitContent] = useState<ExtendedHeaUnitFragment | null | undefined>();
  const [lesson, setLesson] = useState<Lesson | undefined>();
  const [section, setSection] = useState<Section | undefined>();
  const [content, setContent] = useState<Content | undefined>();
  const [selectionLevel, setSelectionLevel] = useState<SelectionLevel>();
  const [isPreparation, setIsPreparation] = useState<boolean>();
  const setUnit = useCallback((p: ExtendedUnitWithHeaFragment) => {
    setUnitContent(p);
  }, []);

  const setHeaUnit = useCallback((p?: ExtendedHeaUnitFragment | null) => {
    setHeaUnitContent(p);
  }, []);

  return (
    <EditUnitContext.Provider value={{
      unit,
      setUnit,
      heaUnit,
      setHeaUnit,
      lesson,
      setLesson,
      section,
      setSection,
      content,
      setContent,
      selectionLevel,
      setSelectionLevel,
      isPreparation,
      setIsPreparation
    }}>
      {children}
    </EditUnitContext.Provider>
  );
};

export const useEditUnit = () => useContext(EditUnitContext);
